import { restClient } from 'config/store/configureStore';

import { USERS_FILTER_URL, USERS_SEARCH_FIND_ALL_BY_DEALER_URL, USERS_USERNAME_CHECK_URL, USERS_API_URL } from 'constants/ApiConstants';

import { resolveLink } from '../UrlResolver';

export default {
  getUsers: (link, parameters) => {
    const filterUrl = USERS_FILTER_URL;
    const { url, params } = resolveLink(link, filterUrl, parameters);
    return restClient.get(url, {
      params: {
        ...params,
        fields: 'id,displayName,username,roles,status,firstName,lastName', //! FIXME: Remove this. Parameters should never be set in the service !
      },
    });
  },

  // Temporary function. It's what `getUsers` should look like, but as it's a sensitive operation, I leave it for when the application will be more stable.
  fetchUsers: (link, parameters) => {
    const filterUrl = USERS_FILTER_URL;
    const { url, params } = resolveLink(link, filterUrl, parameters);
    return restClient.get(url, { params });
  },

  getUsersForAudit: params =>
    restClient.get(USERS_SEARCH_FIND_ALL_BY_DEALER_URL, {
      params,
    }),

  getUser: userId => restClient.get(`${USERS_API_URL}/${userId}`),

  createUser: user => restClient.post(USERS_API_URL, user),

  userExists: username => {
    const params = { username };
    return restClient.head(USERS_USERNAME_CHECK_URL, { params });
  },

  uploadPicture: (userId, picture, extension) => {
    const params = {
      extension,
    };
    return restClient.post(`${USERS_API_URL}/${userId}/profile-picture`, picture, { params });
  },

  deletePicture: userId => restClient.delete(`${USERS_API_URL}/${userId}/profile-picture`),

  fetchPicture: userId => restClient.get(`${USERS_API_URL}/${userId}/profile-picture`),
};
